import { FunctionComponent } from 'react'
import { useQuery } from 'react-query'
import { useParams, useHistory } from 'react-router-dom'
import { useOnboardContext } from 'modules/onboarding/context'
import { Heading, Paragraph, Button } from '@tmov/design-system'
import { SpinnerLong } from '@tmov/design-system/icons'
import CapaParceiros from 'shared/assets/images/imagem-grande-tela-parceiros.png'
import { Container, Header, Loading, Error } from './styles'

import { steps } from 'modules/onboarding'

import HttpCliente from 'shared/httpClients/frotista.api'

type TProps = {
  setSelectedStep?(step: number): void
}

type TParams = {
  token: string
}

const api = new HttpCliente().api()

const BemVindo: FunctionComponent<TProps> = ({ setSelectedStep }) => {
  const history = useHistory()
  const params = useParams<TParams>()

  const { state, dispatch } = useOnboardContext()

  const { isLoading, isSuccess, isError } = useQuery({
    queryKey: ['getDataFrotista'],
    queryFn: () => api.get(`/parceiros/${params?.token}`),
    onSuccess: res => {
      if (res?.data === null || res?.data === undefined) {
        history.push('/')
      }
      dispatch({
        ...state,
        cnpj: res?.data?.cnpj,
        email: res?.data?.email,
      })
    },
  })

  if (isError) {
    return (
      <Error>
        <Heading variant="h4">
          Houve um erro na hora de consultar dados de pré-cadastro.
        </Heading>
        <Button variant="contained" size="lg" onClick={() => history.push('/')}>
          Ir para login
        </Button>
      </Error>
    )
  }

  if (isLoading && !isSuccess) {
    return (
      <Loading>
        <SpinnerLong />
      </Loading>
    )
  }

  return (
    <Container>
      <div>
        <img className="capa" src={CapaParceiros} />
      </div>
      <div>
        <Header />
        <div>
          <Heading variant="h2">
            Seja bem-vindo(a) ao Tmov Portal Parceiros!
          </Heading>
          <Paragraph variant="p1">
            Aqui você, nesse espaço, vai receber ofertas de lotes direcionados
            para otimizar a sua operação e consolidar sua parceria.
          </Paragraph>
        </div>
        <Heading variant="h3">Vamos iniciar o seu cadastro?</Heading>
        <Button
          variant="contained"
          size="lg"
          onClick={() => {
            setSelectedStep(steps.Terms)
          }}
        >
          Iniciar
        </Button>
      </div>
    </Container>
  )
}

export default BemVindo
